export default {"src":"/_next/static/media/driver-license.17d82e81.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};